import { FC } from 'react';
import Abipruefungen from './Abipruefungen.svg';
import Acker from './Acker.svg';
import AoGrenzen from './Arzte-Ohne-Grenzen.svg';
import Auer from './Auer.svg';
import Aulis from './Aulis.svg';
import Bange from './Bange.svg';
import Bettermarks from './bettermarks.svg';
import Betzold from './Betzold.svg';
import BMVI from './BMVI.svg';
import CarlAuer from './Carl-Auer.svg';
import Dare2Care from './dare2care.svg';
import DFS from './Deutsche-Flugsicherung.svg';
import DeinUnterrichtsmaterial from './deinUnterrichtsmaterial.svg';
import dpaInfografik from './dpa-infografik.svg';
import dtv from './dtv.svg';
import Edeos from './Edeos.svg';
import elkVerlag from './elk.svg';
import eduhu from './eduhu.svg';
import eDidact from './eDidact.svg';
import EKS from './Ernst-Klett-Sprachen.svg';
import ESRI from './ESRI.svg';
import Friedrich from './Friedrich.svg';
import Freyspiel from './Schoolgames.svg';
import FSelbstkontrolleM from './Freiwillige-Selbstkontrolle-Multimedia.svg';
import GundaFrey from './Gunda-Frey.svg';
import Herolé from './Herole.svg';
import JO from './Jung-Oesterreich.svg';
import KICampus from './KI-Campus.svg';
import KlassenzimmerZukunft from './KlassenzimmerZukunft.svg';
import klettLerntraining from './Klett-Lerntraining.svg';
import KlettMEX from './KlettMEX.svg';
import klettKallmeyer from './Klett-Kallmeyer.svg';
import Klinkhardt from './Klinkhardt.svg';
import Klippert from './Klippert-Medien.svg';
import Klischeefrei from './klischeefrei.svg';
import KohlVerlag from './kohl.svg';
import KrappGutknecht from './krappgutknecht.svg';
import Langenscheidt from './Langenscheidt.svg';
import Lehrerbuero from './lehrerbuero.svg';
import Lernbiene from './Lernbiene.svg';
import LetsMINT from './Lets-Mint.svg';
import Medienblau from './On-Interaktiv.svg';
import MedienLB from './MedienLB.svg';
import meinUnterricht from './meinUnterricht.svg';
import MeisterCody from './meister-cody.svg';
import Mildenberger from './Mildenberger.svg';
import Oxfam from './Oxfam.svg';
import Persen from './Persen.svg';
import pictureAlliance from './pa-picture-alliance.svg';
import PONS from './PONS.svg';
import Raabe from './RAABE.svg';
import SchilfAkademie from './Schilf-Akademie.svg';
import Schulfilme from './Schulfilme.svg';
import Schulflix from './Schulflix.svg';
import scolix from './scolix.svg';
import Studyflix from './Studyflix.svg';
import Teachino from './Teachino.svg';
import TerraX from './OER.svg';
import UNICEF from './unicef.svg';
import UTB from './UTB.svg';
import VerlagAnDerRuhr from './verlag-an-der-ruhr.svg';
import VuR from './vur.svg';
import Waxmann from './waxmann.svg';
import Welttierschutz from './Welttierschutzgesellschaft.svg';
import wheelmap from './Wheelmap.svg';
import YAEZ from './YAEZ.svg';
import YCC from './yourCOOLcontrol.svg';
import dieSprachzeitung from './die_sprachzeitung.svg';
import investIt from './invest-it.svg';
import psychiatrieVerlag from './psychiatrie-verlag.svg';
import wochenschau from './wochenschau.svg';
import AdenauerCampus from './adenauer-campus.svg';
import ArolsenArchives from './arolsen_archives.svg';
import BrotFuerDieWelt from './brot-fuer-die-welt.svg';
import PETAKids from './peta-kids.svg';

type PublisherLogo = FC<{ className?: string }>;

export const publisherImages: Record<string, PublisherLogo> = {
  Acker,
  Abipruefungen,
  'Adenauer Campus': AdenauerCampus,
  AoGrenzen,
  'Arolsen Archives': ArolsenArchives,
  Auer,
  Aulis,
  Bange,
  Betzold,
  Bettermarks,
  BMVI,
  'Brot für die Welt': BrotFuerDieWelt,
  'Carl-Auer': CarlAuer,
  Dare2Care,
  DeinUnterrichtsmaterial,
  DFS,
  'dpa-infografik': dpaInfografik,
  dtv,
  Edeos,
  'elk Verlag': elkVerlag,
  eduhu,
  eDidact,
  EKS,
  ESRI,
  Freyspiel,
  Friedrich,
  FSelbstkontrolleM,
  'Gunda Frey': GundaFrey,
  Herolé,
  'Initiative Klischeefrei': Klischeefrei,
  'Jungoesterreich': JO,
  'JPP Medien': Schulfilme,
  'KI Campus': KICampus,
  KlassenzimmerZukunft,
  'Klett Lerntraining': klettLerntraining,
  KlettMEX,
  'Klett Kallmeyer': klettKallmeyer,
  Klinkhardt,
  Klippert,
  'Kohl Verlag': KohlVerlag,
  'Krapp & Gutknecht Verlag': KrappGutknecht,
  Langenscheidt,
  Lehrerbuero,
  Lernbiene,
  LetsMINT,
  Medienblau,
  MedienLB,
  meinUnterricht,
  'Meister Cody': MeisterCody,
  MGO: eDidact,
  Mildenberger,
  Oxfam,
  Persen,
  PETAKids,
  'picture-alliance': pictureAlliance,
  PONS,
  Raabe,
  SchilfAkademie,
  Schulflix,
  scolix,
  Studyflix,
  Teachino,
  TerraX,
  UNICEF,
  UTB,
  'Verlag an der Ruhr': VerlagAnDerRuhr,
  VuR,
  Waxmann,
  Welttierschutz,
  wheelmap,
  YAEZ,
  'yourCOOLcontrol':YCC,
  'Die Sprachzeitung': dieSprachzeitung,
  'Invest it!': investIt,
  'Psychiatrie Verlag': psychiatrieVerlag,
  'Wochenschau Verlag': wochenschau
};

const getPublisherLogo = (publisherName: string) => publisherImages[publisherName];

export default getPublisherLogo;
